import { render, staticRenderFns } from "./OptionsKids.vue?vue&type=template&id=3c6733ee&scoped=true"
import script from "./OptionsKids.vue?vue&type=script&lang=js"
export * from "./OptionsKids.vue?vue&type=script&lang=js"
import style0 from "./OptionsKids.vue?vue&type=style&index=0&id=3c6733ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6733ee",
  null
  
)

export default component.exports